var _styled;

import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { GREY_1 } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants'; // The line-height and padding for supporting headers does not follow any pre-existing patterns

var customLineHeight = '1.11111';
var smallPaddingBottom = '7px';
var largePaddingBottom = '6px';
var StyledHeader = styled('span')((_styled = {
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_20,
  lineHeight: customLineHeight,
  color: GREY_1,
  paddingBottom: smallPaddingBottom
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_27,
  lineHeight: LINE_HEIGHT.SIZE_27,
  paddingBottom: largePaddingBottom
}, _styled));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <SupportingHeader>Heading text</SupportingHeader>
 * ```
 *
 * With another header
 * ```jsx
 * import { H1 } from '@govuk-react/header';
 *
 * <SupportingHeader>Supporting header text</SupportingHeader>
 * <H1>Main header text</H1>
 * ```
 *
 * ### References
 * - https://govuk-elements.herokuapp.com/typography/
 */

var SupportingHeader = function SupportingHeader(props) {
  return React.createElement(StyledHeader, props);
};

export default withWhiteSpace({
  marginBottom: 0
})(SupportingHeader);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/supporting-header/es/index.js
// module id = 315
// module chunks = 0